module.exports = __webpack_public_path__ + "static/media/gu.b7962221.svg";